var _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 133,
    height: 48,
    viewBox: "0 0 133 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3078 1.39478H20.793V44.654H48.3078V1.39478Z",
    fill: "#B3D4D8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9853 1.39478H20.793V44.654H23.9853V1.39478Z",
    fill: "#006E7E"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.19
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.4189 1.39478H45.2266V44.654H48.4189V1.39478Z",
    fill: "#006E7E"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5398 15.6624C30.1531 15.6624 26.6133 19.2021 26.6133 23.5889V44.6539H42.488V23.5889C42.488 19.2021 38.9482 15.6624 34.5398 15.6624Z",
    fill: "#E6F1F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M118.301 9.3645H48.3086V44.6755H118.301V9.3645Z",
    fill: "#006E7E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2134 12.7737H53.8008V44.6535H54.2134V12.7737Z",
    fill: "#00424C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6294 12.7737H54.2168V44.6535H54.6294V12.7737Z",
    fill: "#B3D4D8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8267 12.7737H62.4141V44.6535H62.8267V12.7737Z",
    fill: "#00424C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2427 12.7737H62.8301V44.6535H63.2427V12.7737Z",
    fill: "#B3D4D8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4146 12.7742H71.002V44.654H71.4146V12.7742Z",
    fill: "#00424C"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8267 12.7742H71.4141V44.654H71.8267V12.7742Z",
    fill: "#B3D4D8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0259 12.7737H79.6133V44.6535H80.0259V12.7737Z",
    fill: "#00424C"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.438 12.7737H80.0254V44.6535H80.438V12.7737Z",
    fill: "#B3D4D8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6157 12.7737H88.2031V44.6535H88.6157V12.7737Z",
    fill: "#00424C"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0493 12.7737H88.6367V44.6535H89.0493V12.7737Z",
    fill: "#B3D4D8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2271 12.7737H96.8145V44.6535H97.2271V12.7737Z",
    fill: "#00424C"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6411 12.7737H97.2285V44.6535H97.6411V12.7737Z",
    fill: "#B3D4D8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M105.817 12.7739H105.404V44.6537H105.817V12.7739Z",
    fill: "#00424C"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M106.252 12.7737H105.84V44.6535H106.252V12.7737Z",
    fill: "#B3D4D8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M114.424 12.7737H114.012V44.6535H114.424V12.7737Z",
    fill: "#00424C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M114.838 12.7737H114.426V44.6535H114.838V12.7737Z",
    fill: "#B3D4D8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M119.778 9.3645H48.3086V13.7078H119.778V9.3645Z",
    fill: "#D7D7D7"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.778 20.7007H48.3086V25.044H119.778V20.7007Z",
    fill: "#D7D7D7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M119.778 32.0366H48.3086V36.3799H119.778V32.0366Z",
    fill: "#D7D7D7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.947 44.6541H9.37109V47.1514H123.947V44.6541Z",
    fill: "#00424C"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6198 0.989502V44.5092H13.5605V9.41514C13.5605 4.74482 17.1525 0.989502 21.6198 0.989502Z",
    fill: "#E6F1F2"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8126 1.79541C17.1398 2.33891 14.3652 5.367 14.3652 9.11328V43.7033H20.8126V1.79541Z",
    fill: "#B3D4D8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 11.406H11.1309V12.405H22.2714V11.406Z",
    fill: "#4D9AA5"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 13.2302H11.1309V14.2292H22.2714V13.2302Z",
    fill: "#4D9AA5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 15.0542H11.1309V16.0532H22.2714V15.0542Z",
    fill: "#4D9AA5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 16.8567H11.1309V17.8556H22.2714V16.8567Z",
    fill: "#4D9AA5"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 18.6812H11.1309V19.6801H22.2714V18.6812Z",
    fill: "#4D9AA5"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 20.4836H11.1309V21.4826H22.2714V20.4836Z",
    fill: "#4D9AA5"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2714 22.3079H11.1309V23.3068H22.2714V22.3079Z",
    fill: "#4D9AA5"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5399 16.7485C30.7395 16.7485 27.6992 19.7888 27.6992 23.5892V44.6542H41.3806V23.5892C41.3806 19.7888 38.362 16.7485 34.5399 16.7485Z",
    fill: "#00424C"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4547 34.3821C30.0431 34.3821 28.9355 35.4896 28.9355 36.9012V44.654H33.9738V36.9012C33.9738 35.5113 32.8662 34.3821 31.4547 34.3821ZM37.6221 34.3821C36.2106 34.3821 35.103 35.4896 35.103 36.9012V44.654H40.1413V36.9012C40.1413 35.5113 39.0337 34.3821 37.6221 34.3821Z",
    fill: "#0A0A0A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLogo);
export default __webpack_public_path__ + "static/media/providerLogo.c9d64a71a3ed42e9c53872f7b6340859.svg";
export { ForwardRef as ReactComponent };